import {useContext, useEffect, useState} from "react";
import {CustomImport, supportService} from "services/supportService";
import {AuthContext} from "contexts";
import {Button, Form, Modal} from "react-bootstrap";

export const TranslationsPage = () => {
    const {env} = useContext(AuthContext);

    const [imports, setImports] = useState<CustomImport[]>([]);
    const [selectedImport, setSelectedImport] = useState<CustomImport | null>(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const [logs, setLogs] = useState<string[]>([]);


    const onUploadModalOpen = () => {
        setLogs([]);
        setIsModalVisible(true);
        if (!selectedImport && imports.length > 0) {
            setSelectedImport(imports[0]);
        }
    }

    const onHideModal = () => {
        if (isUploading) {
            return;
        }
        setIsModalVisible(false);
        setSelectedImport(null);
        setLogs([]);
    }

    const onUploadClick = async () => {
        if (!env || !selectedImport) return;

        setIsUploading(true);
        try {
            const uploadLogs = await supportService.uploadImport(env, {
                name: selectedImport.name ? selectedImport.name : selectedImport.category
            });
            setLogs(uploadLogs ?? []);
        } finally {
            setIsUploading(false);
        }
    }


    useEffect(() => {
        if (!env) {
            return
        }

        supportService.getImports(env).then((imports: CustomImport[]) => {
            const grouped = imports.reduce<Record<string, CustomImport[]>>((acc, item) => {
                if (!acc[item.category]) acc[item.category] = [];
                acc[item.category].push(item);
                return acc;
            }, {});

            const result: CustomImport[] = Object.entries(grouped).flatMap(([category, items]) => {
                // if only one item and its name equals the category, keep it as is
                if (items.length === 1 && items[0].name === category) {
                    return items;
                }
                // otherwise, add a header + all items
                return [{name: "", category}, ...items];
            });
            setImports(result);
        });
    }, []);


    return <div className="p-4">
        <p>Загрузки переводов
            <a target="_blank"
               href="https://www.notion.so/Importing-Data-Formats-29c90b65869080d3be03f75c6d022d3d?source=copy_link"
               rel="noreferrer"
               className="mx-2">
                Документация
            </a>
        </p>
        <div className="mb-3">
            <Button
                variant="primary"
                onClick={onUploadModalOpen}>
                Загрузить переводы
            </Button>
        </div>
        <Modal show={isModalVisible} onHide={onHideModal}>
            <Modal.Header closeButton>
                <Modal.Title>Загрузка переводов{selectedImport ? `: ${selectedImport.name}` : ''}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Тип загрузки</Form.Label>
                        <Form.Select
                            value={selectedImport?.name ?? ''}
                            onChange={(e) => {
                                const next = imports.find(i => i.name === e.target.value) ?? null;
                                setSelectedImport(next);
                            }}
                            disabled={isUploading}
                        >
                            {imports.length === 0 && <option value="">Нет доступных загрузок</option>}
                            {imports.map((i) => (
                                <option key={i.category + i.name}
                                        value={i.name}>{i.name !== i.category && i.name ? `${i.category}: ` : i.category} {i.name !== i.category ? i.name : ''}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Form>
                {logs.length > 0 && (
                    <div className="mt-3">
                        <div className="fw-bold mb-2">Логи:</div>
                        <div className="border rounded p-2 bg-light" style={{maxHeight: '400px', overflowY: 'auto'}}>
                            {logs.map((l, i) => (
                                <div key={`${i}-${l.slice(0, 10)}`}>{l}</div>
                            ))}
                        </div>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setIsModalVisible(false)} disabled={isUploading}>
                    Закрыть
                </Button>
                <Button
                    variant="primary"
                    disabled={!selectedImport || !env || isUploading}
                    onClick={onUploadClick}
                >
                    {isUploading ? 'Загрузка...' : 'Загрузить'}
                </Button>
            </Modal.Footer>
        </Modal>
    </div>
}